function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient4821",
  y2: 1032.9,
  xlinkHref: "#linearGradient5030",
  gradientUnits: "userSpaceOnUse",
  x2: -178.41,
  gradientTransform: "translate(589.13 -741.51)",
  y1: 1024.1,
  x1: -178.41
});

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient4825",
  y2: 1030.3,
  xlinkHref: "#linearGradient5030",
  gradientUnits: "userSpaceOnUse",
  x2: 181.53,
  gradientTransform: "translate(-589.13 -741.92)",
  y1: 1027.4,
  x1: 181.53
});

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient4832",
  y2: 1032.9,
  xlinkHref: "#linearGradient4924",
  gradientUnits: "userSpaceOnUse",
  x2: -178.41,
  gradientTransform: "translate(529.13 -741.51)",
  y1: 1024.1,
  x1: -178.41
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient4836",
  y2: 1030.3,
  xlinkHref: "#linearGradient4924",
  gradientUnits: "userSpaceOnUse",
  x2: 181.53,
  gradientTransform: "translate(-529.13 -741.92)",
  y1: 1027.4,
  x1: 181.53
});

var SvgWhiteboard = function SvgWhiteboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    viewBox: "0 0 423 294",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5030"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop5032",
    style: {
      stopColor: "#2f3786"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5034",
    style: {
      stopColor: "#2f4291"
    },
    offset: 0.24327
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5036",
    style: {
      stopColor: "#2a529f"
    },
    offset: 0.38978
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5038",
    style: {
      stopColor: "#323a8b"
    },
    offset: 0.5567
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5040",
    style: {
      stopColor: "#2f3f8e"
    },
    offset: 0.60313
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5042",
    style: {
      stopColor: "#2f3e8f"
    },
    offset: 0.64957
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5044",
    style: {
      stopColor: "#2c4794"
    },
    offset: 0.756
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5046",
    style: {
      stopColor: "#2a4b98"
    },
    offset: 0.86244
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop5048",
    style: {
      stopColor: "#1d2e88"
    },
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4924"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4926",
    style: {
      stopColor: "#000000"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4928",
    style: {
      stopColor: "#787878"
    },
    offset: 0.24327
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4930",
    style: {
      stopColor: "#787878"
    },
    offset: 0.38978
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4932",
    style: {
      stopColor: "#000000"
    },
    offset: 0.5567
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4944",
    style: {
      stopColor: "#242424"
    },
    offset: 0.60313
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4934",
    style: {
      stopColor: "#000000"
    },
    offset: 0.64957
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4940",
    style: {
      stopColor: "#645c5e"
    },
    offset: 0.756
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4936",
    style: {
      stopColor: "#645c5d"
    },
    offset: 0.86244
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4938",
    style: {
      stopColor: "#000000"
    },
    offset: 1
  })), _ref2, _ref3, _ref4, _ref5, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4844",
    y2: 992.69,
    gradientUnits: "userSpaceOnUse",
    x2: -298.43,
    gradientTransform: "translate(757.7 -695.38)",
    y1: 985.69,
    x1: -298.43
  }, /*#__PURE__*/React.createElement("stop", {
    id: "stop4840",
    style: {
      stopColor: "#888a85"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "stop4842",
    style: {
      stopColor: "#898b86"
    },
    offset: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g4896",
    transform: "translate(-332.27 -4.8172)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect4786",
    style: {
      fill: "#ffffff"
    },
    height: 270,
    width: 405,
    y: 13.817,
    x: 341.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4788",
    style: {
      fill: "#babdb6"
    },
    rx: 4.5,
    ry: 4.5,
    height: 288,
    width: 9,
    y: 4.8172,
    x: 746.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4790",
    style: {
      fill: "#babdb6"
    },
    transform: "rotate(90)",
    height: 414,
    width: 9,
    y: -750.77,
    x: 4.8172
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4792",
    style: {
      fill: "#babdb6"
    },
    transform: "rotate(90)",
    height: 414,
    width: 9,
    y: -750.77,
    x: 283.82
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4796",
    style: {
      fill: "#101010"
    },
    transform: "rotate(90)",
    height: 36,
    width: 12,
    y: -731.75,
    x: 282.8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4794",
    style: {
      fill: "#babdb6"
    },
    rx: 4.5,
    ry: 4.5,
    height: 288,
    width: 9,
    y: 4.8172,
    x: 332.27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4804",
    style: {
      fill: "url(#linearGradient4836)"
    },
    transform: "scale(-1,1)",
    rx: 0.56186,
    ry: 0.68553,
    height: 4,
    width: 3,
    y: 284.99,
    x: -348.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4800",
    style: {
      fill: "#ececec"
    },
    transform: "scale(-1,1)",
    rx: 1.2266,
    ry: 1.3127,
    height: 9,
    width: 40,
    y: 282.49,
    x: -398.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4802",
    style: {
      fill: "url(#linearGradient4832)"
    },
    d: "m358.13 283.49-4-1h-6v9h6l4-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4993",
    style: {
      fill: "url(#linearGradient4825)"
    },
    transform: "scale(-1,1)",
    rx: 0.56186,
    ry: 0.68553,
    height: 4,
    width: 3,
    y: 284.99,
    x: -408.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4995",
    style: {
      fill: "#ececec"
    },
    transform: "scale(-1,1)",
    rx: 1.2266,
    ry: 1.3127,
    height: 9,
    width: 40,
    y: 282.49,
    x: -458.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4997",
    style: {
      fill: "url(#linearGradient4821)"
    },
    d: "m418.13 283.49-4-1h-6v9h6l4-1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect4806",
    style: {
      fill: "url(#linearGradient4844)"
    },
    height: 9,
    width: 405,
    y: 289.82,
    x: 341.27
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhiteboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whiteboard.ad8f89f6.svg";
export { ForwardRef as ReactComponent };